'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timezoneDate = exports.localDate = exports.parseIso8601Date = exports.iso8601Date = exports.tomorrow = exports.today = exports.midnightOnDate = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _timeAndDate = require('constants/time-and-date');

var _tzOffsets = require('tz-offsets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var secondsToTimeString = function secondsToTimeString(time) {
  var hasLeadingZeroForMin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var hrs = Math.floor(time / 3600);
  var mins = Math.floor(time % 3600 / 60);
  var secs = parseInt(time % 60, 10);
  var ret = '';

  if (hrs > 0) {
    ret += ('0' + hrs + ':').slice(-3);
  }

  ret += hasLeadingZeroForMin ? ('0' + mins + ':').slice(-3) : (mins + ':').slice(-3);
  ret += ('0' + secs).slice(-2);
  return ret;
};

var midnightOnDate = exports.midnightOnDate = function midnightOnDate() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
};

var today = exports.today = function today() {
  return midnightOnDate();
};

var tomorrow = exports.tomorrow = function tomorrow() {
  return midnightOnDate(new Date(today().valueOf() + _timeAndDate.DAY_MS));
};

var iso8601Date = exports.iso8601Date = function iso8601Date() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  return [date.getUTCFullYear(), ('0' + (date.getUTCMonth() + 1)).slice(-2), ('0' + date.getUTCDate()).slice(-2)].join('-');
};

var parseIso8601Date = exports.parseIso8601Date = function parseIso8601Date(str) {
  var _str$split = str.split('-'),
      _str$split2 = (0, _slicedToArray3.default)(_str$split, 3),
      year = _str$split2[0],
      month = _str$split2[1],
      date = _str$split2[2];

  return new Date(Date.UTC(year, parseInt(month, 10) - 1, date));
};

var localDate = exports.localDate = function localDate() {
  var dateObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  return [dateObject.getFullYear(), ('0' + (dateObject.getMonth() + 1)).slice(-2), ('0' + dateObject.getDate()).slice(-2)].join('-');
};

var timezoneDate = exports.timezoneDate = function timezoneDate(timezone) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  return localDate((0, _tzOffsets.shiftDateObjectByTimezone)(date, timezone));
};

exports.default = secondsToTimeString;